import { createSelector } from '@reduxjs/toolkit';

import carsDataSelector from '@/features/cars/selectors/data';

import optionsSelector from './options';

const totalPagesSelector = createSelector(
  [carsDataSelector, optionsSelector],
  (carsData, options) => {
    if (!carsData.data) {
      return 0;
    }
    return Math.ceil(carsData.data.total / options.pageSize);
  },
);

export default totalPagesSelector;
